import { SDK } from '@directus/sdk-js/dist/esm/index.js';

try {
	var url = window.location.href;
	var captured = /host=([^&]+)/.exec(url)[1]; // Value is in [1] ('384' in our case)
	var result = captured ? captured : 'myDefaultValue';

	console.log(result);
} catch (e) {
	() => {
		return null;
	};
}

const path = window.location.pathname;
const parts = path.split('/');
const adminIndex = parts.indexOf('admin');
let apiRootPath = parts.slice(0, adminIndex).join('/') + '/';

const client = new SDK({
	mode: 'cookie',
	url: apiRootPath
});

export default client;
